// English translation

const en = {
  "menu.company_integration_financial": "Integración Financiera",
};

export default en;
